import ReactDom from 'react-dom';

import styled from 'styled-components';

const Wrap = styled.div`
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: ${(props) => props.theme.videoZIndex.bottomPopup};
  background: rgba(51, 57, 64, 0.85);
  border-radius: 4px;

  &.toast {
    z-index: ${(props) => props.theme.zIndex.toast};
  }
`;

const PopupVideoWrap = (props) => {
  let el = document.getElementById('videoBox');
  if (el) {
    return ReactDom.createPortal(<Wrap {...props}></Wrap>, el);
  }
  return null;
};

export default PopupVideoWrap;
